<template>
  <div
    style="height: 100vh"
    class="d-flex flex-column align-center justify-center"
  >
    <div
      class="d-flex flex-column align-center justify-center"
      style="max-width: 300px"
    >
      <img
        style="width: 50px; height: 50px"
        :src="require('@/assets/logo/logo-dark.svg')"
        class="mb-8"
      />
      <v-alert
        width="100%"
        class="mb-4"
        v-if="reason && reason === 'Unauthorized'"
        type="info"
        style="font-size: 10pt; padding: 10% 5%"
        text="You tried to login with an email that does not have access yet."
      ></v-alert>
      <p style="font-size: 14pt; text-align: center" class="mb-5">
        Restricted access
      </p>

      <!-- <v-text-field
        variant="solo"
        flat
        bg-color="white"
        label="Password"
        style="width: 100%"
        v-model="password"
        @keyup.enter="access"
      >
        <template v-slot:append-inner>
          <v-btn
            @click="access"
            icon="mdi-send"
            size="small"
            variant="flat"
          ></v-btn>
        </template>
      </v-text-field> -->
      <p style="font-size: 10pt; text-align: center">
        If you haven't signed up for the waiting list,
        <a href="http://app.stix.social/waiting-list">sign up here.</a><br />
        <br />Stix is onboarding companies in an easy pace. If you have
        questions about your place on the waiting list,
        <a href="mailto:info@stix.social">send us an email.</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reason: null,
    };
  },
  mounted() {
    this.reason = this.$route.query?.reason || null;
  },
  methods: {
    access() {
      this.password = "";
      this.$store.commit("setNotification", {
        show: true,
        text: "Password incorrect. Please try again.",
        type: "error",
        icon: "",
      });
      // this.$router.push("/access");
    },
  },
};
</script>
